import { render, staticRenderFns } from "./mainQuick.vue?vue&type=template&id=167212c5&"
import script from "./mainQuick.vue?vue&type=script&lang=ts&"
export * from "./mainQuick.vue?vue&type=script&lang=ts&"
import style0 from "./mainQuick.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports